var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25012H9.75V9.75012H3.75V12.0001L0 9.00012L3.75 6.00012V8.25012ZM3 13.5001H5.031C5.89702 14.2639 6.96502 14.7615 8.10685 14.9333C9.24868 15.1051 10.4158 14.9438 11.4683 14.4687C12.5207 13.9937 13.4137 13.225 14.0401 12.255C14.6664 11.285 14.9996 10.1548 14.9996 9.00012C14.9996 7.84544 14.6664 6.71528 14.0401 5.74526C13.4137 4.77525 12.5207 4.00658 11.4683 3.5315C10.4158 3.05642 9.24868 2.8951 8.10685 3.06692C6.96502 3.23873 5.89702 3.73637 5.031 4.50012H3C3.698 3.56801 4.60375 2.81151 5.6453 2.29073C6.68686 1.76995 7.83551 1.49925 9 1.50012C13.1423 1.50012 16.5 4.85787 16.5 9.00012C16.5 13.1424 13.1423 16.5001 9 16.5001C7.83551 16.501 6.68686 16.2303 5.6453 15.7095C4.60375 15.1887 3.698 14.4322 3 13.5001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e23ef51f.svg";
export { ForwardRef as ReactComponent };